import { render, staticRenderFns } from "./MoreBtn.vue?vue&type=template&id=5fe3cbc2&scoped=true&"
import script from "./MoreBtn.vue?vue&type=script&lang=js&"
export * from "./MoreBtn.vue?vue&type=script&lang=js&"
import style0 from "./MoreBtn.vue?vue&type=style&index=0&id=5fe3cbc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe3cbc2",
  null
  
)

export default component.exports